import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    themeSwitcherContent: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    }
}));